namespace Matrix.Administration {
    export interface UserRoleUpdateRequest extends Serenity.ServiceRequest {
        Username?: string;
        RoleNames?: string[];
    }
}
